import {Project} from "../../domain/model/project";
import {Customer} from "../../domain/model/customer";
import {Contract} from "../../domain/model/contract";

// client contract detail
interface ICreateContractByClientResponse {

    contract?: Contract;

}
class CreateContractByClientResponse implements ICreateContractByClientResponse {

    public contract: Contract;

}

interface IUpdateContractByClientResponse {

    contract?: Contract;

}
class UpdateContractByClientResponse implements IUpdateContractByClientResponse {

    public contract: Contract;

}

interface IOpenCreateFormContractByClientResponse {

    project?: Project;
    customer?: Customer;
    contract?: Contract;

}
class OpenCreateFormContractByClientResponse implements IOpenCreateFormContractByClientResponse {

    public project: Project;
    public customer: Customer;
    public contract: Contract;

}

// client contract list
interface IGetAllContractListByClientResponse {

    projectList?: Project[];
    customerList?: Customer[];
    contractList?: Contract[];
    contractCount?: number;

}
class GetAllContractListByClientResponse implements IGetAllContractListByClientResponse {

    public projectList: Project[];
    public customerList: Customer[];
    public contractList: Contract[];
    public contractCount: number;

}

export {
    // client contract detail
    CreateContractByClientResponse,
    UpdateContractByClientResponse,
    OpenCreateFormContractByClientResponse,
    // client contract list
    GetAllContractListByClientResponse,
}



// WEBPACK FOOTER //
// ./src/presentation/response/contract_response.ts